import { type AxiosError, AxiosHeaders } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  ContactControllerApiFactory,
  type RXCallbackRequestV1,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../api'
import { useGlobalConfigContext } from '../../global-config'

const getUseApiSwrMediServiceContactRxCallbackMutation = (): string =>
  'useApiSwrMediServiceContactRxCallbackMutation'

export const useApiSwrMediServiceContactRxCallbackMutation =
  (): SWRMutationResponse<unknown, AxiosError, string, RXCallbackRequestV1> => {
    const globalConfig = useGlobalConfigContext()
    const client = useGlooApi(ContactControllerApiFactory)

    return useSWRMutation(
      getUseApiSwrMediServiceContactRxCallbackMutation(),
      async (
        _swrKey: string,
        data: { arg: RXCallbackRequestV1 },
      ): Promise<unknown> => {
        const response = await client.contactV1TenantLanguageRxCallbackPost({
          language: globalConfig.language,
          RXCallbackRequestV1: data.arg,
          tenant: globalConfig.tenantAndEnv,
        })

        return response.headers instanceof AxiosHeaders
          ? response.headers.get('date')
          : ''
      },
    )
  }
